import { useState } from "react";

import DeleteModal from "app/pages/activation/components/Settings/DeleteModal/DeleteModal";
import DeleteSet from "app/pages/activation/components/Settings/DeleteSet/DeleteSet";
import useDeleteActivation from "app/pages/activation/queries/data/useDeleteActivation";

type DeleteSetSchema = {
    activationId: string;
    isViewerMode: boolean;
    topicsCount: number;
};

export const DeleteSetSection = ({ activationId, isViewerMode, topicsCount }: DeleteSetSchema) => {
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const { mutate: deleteActivation } = useDeleteActivation(activationId);

    const onDelete = (shouldRemoveKWList: boolean) => {
        if (!activationId) {
            return;
        }

        deleteActivation({ id: activationId, shouldRemoveKWList });
    };

    return (
        <>
            <DeleteSet
                onClick={() => setIsDeleteModalOpen(true)}
                isViewerMode={isViewerMode}
            />

            <DeleteModal
                isOpen={isDeleteModalOpen}
                onCancel={() => setIsDeleteModalOpen(false)}
                onDelete={onDelete}
                topicsCount={topicsCount}
            />
        </>
    );
};
